'use strict';

function LocalizationLoaderService($q, $http, $translateStaticFilesLoader, PolopolyFSFileService) {
  function getExtra(seq, contentId, key) {
    return PolopolyFSFileService.getFile(contentId, 'locale-' + key + '.json').then(function (file) {
      return [seq, JSON.parse(file)];
    }, function () {
      return [seq, undefined];
    });
  }

  function getStaticFiles(options) {
    return $translateStaticFilesLoader(options).then(function (data) {
      return [0, data];
    });
  }

  function getMergedLocale(options) {
    var key = options.key;
    var seq = options.seq || 0;
    return $http({
      url: '../onecms/dam/locales/desk/locale/locale-' + key + '.json',
      method: 'GET'
    })
    .then(function(result) {
      return [seq, result.data];
    }, function () {
      return $q.reject(key);
    });
  }

  return function(options) {
    var promises = [];

    // Request static language
    promises.push(getStaticFiles(options));

    // Request merged language
    promises.push(getMergedLocale({
      key: options.key,
      seq: 1
    }));

    return $q.all(promises).then( function (data) {
      var length = data.length;
      var mergedData = {};
      var orderedData = data.sort(function (a, b){return a[0] - b[0];});
      for (var i = 0; i < length; i++) {
        if (typeof orderedData[i][1] !== 'undefined') {
          $.extend(true, mergedData, orderedData[i][1]);
        }
      }
      return mergedData;
    });
  };
}

angular.module('atex.dam').factory('DamLocalizationLoaderService', ['$q', '$http', '$translateStaticFilesLoader', 'PolopolyFSFileService', LocalizationLoaderService]);
